export default __webpack_public_path__ + "static/landing-c35ad81d8e669d6cdbbfd30acc8cadef.png";